import { routeUrl } from "@/app/routes";
import { initials } from "@/features/copilot/components/read-cards/people-read-card";
import {
  READ_CARD_ROW_LIMIT,
  ReadCardFrame,
} from "@/features/copilot/components/read-cards/read-card-frame";
import type { AbsenteeItem } from "@/features/copilot/schemas/copilot-read-cards.schema";
import { Avatar, AvatarFallback } from "@/shared/components/ui/avatar";
import { formatDateOnly } from "@/shared/lib/format-date-only";

function absenceSpan(item: AbsenteeItem): string {
  const from = formatDateOnly(item.fromDate);
  const to = formatDateOnly(item.toDate);
  if (!from) return to ?? "";
  return !to || to === from ? from : `${from} to ${to}`;
}

export function AbsenteesReadCard({
  items,
  date,
  slug,
  hasMore = false,
}: {
  items: AbsenteeItem[];
  date?: string;
  slug: string;
  hasMore?: boolean;
}) {
  const shown = items.slice(0, READ_CARD_ROW_LIMIT);
  return (
    <ReadCardFrame
      title="Who's away"
      note={formatDateOnly(date ?? null) ?? undefined}
      viewAllHref={routeUrl.leave.team(slug)}
      hiddenCount={items.length - shown.length}
      hasMore={hasMore}
    >
      {shown.map((item) => (
        <li key={`${item.person.id}:${item.fromDate}`}>
          <a
            href={routeUrl.people.detail(slug, item.person.id)}
            className="flex items-center gap-2.5 px-3 py-2 hover:bg-muted/60 focus-visible:outline-2 focus-visible:outline-ring"
          >
            <Avatar size="sm">
              <AvatarFallback className="text-3xs">{initials(item.person.name)}</AvatarFallback>
            </Avatar>
            <span className="min-w-0 flex-1">
              <span className="block truncate">{item.person.name}</span>
              <span className="block truncate text-xs text-text-secondary">
                {absenceSpan(item)}
              </span>
            </span>
          </a>
        </li>
      ))}
    </ReadCardFrame>
  );
}
